import React from 'react'
import { CREDITS_COST, type CreditBalance } from '../../../shared/domain/credits/types.no-deps'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import { INITIAL_PROMPT_ANSWER, ZapBotModalPage, type PromptAnswer } from './ZapBot'
import type { CommonDeps } from '../base/CommonDeps'

type ZapBotContext = {
    creditBalance: Nullable<CreditBalance>
    goBack: () => void
    goToPage: (page: ZapBotModalPage) => void
    hasCredits: boolean
    isLoading: boolean
    page: ZapBotModalPage
    promptAnswer: PromptAnswer
}

export const ZapBotContext = React.createContext<ZapBotContext>({
    creditBalance: null,
    goBack: () => null,
    goToPage: (_: ZapBotModalPage) => null,
    hasCredits: true,
    isLoading: false,
    page: ZapBotModalPage.Main,
    promptAnswer: { ...INITIAL_PROMPT_ANSWER },
})

type ZapBotContextProviderProps = {
    creditBalance: Nullable<CreditBalance>
    goBack: () => void
    goToPage: (page: ZapBotModalPage) => void
    isLoading: boolean
    page: ZapBotModalPage
    promptAnswer: PromptAnswer
    commonDeps: Nullable<CommonDeps>
}

export function ZapBotContextProvider({
    creditBalance,
    goBack,
    goToPage,
    isLoading,
    page,
    promptAnswer,
    children,
    commonDeps,
}: React.PropsWithChildren<ZapBotContextProviderProps>) {
    const hasCredits = commonDeps.user.zapticStaff || !creditBalance || creditBalance.totalBalance >= CREDITS_COST.aika

    return (
        <ZapBotContext.Provider value={{ creditBalance, goBack, goToPage, hasCredits, isLoading, page, promptAnswer }}>
            {children}
        </ZapBotContext.Provider>
    )
}
